// export const locationTypes = ['office', 'training', 'at-client', 'fair', 'home', 'remote', 'conference', 'fieldwork']

const localeFormats = {
  pl: {
    '[Today], MMM D': '[dzisiaj], D MMMM',
    '[Tomorrow], MMM D': '[jutro], D MMMM',
    '[Yesterday], MMM D': '[wczoraj], D MMMM',
    'dddd, MMM D': 'dddd, D MMM',
    'MMM D, YYYY': 'D MMM, YYYY',
    'MMM D': 'D MMM',
    'MMMM D': 'D MMMM',
    'MMMM\xa0D': 'D\xa0MMMM',
    'ddd, MMM D': 'ddd, D MMM',
    'MMMM D, YYYY': 'D MMMM, YYYY',
    'MMMM\xa0D, YYYY': 'D\xa0MMMM, YYYY',
  },
  en_GB: {
    '[Today], MMM D': '[Today], D MMMM',
    '[Tomorrow], MMM D': '[Tomorrow], D MMMM',
    '[Yesterday], MMM D': '[Yesterday], D MMMM',
    'dddd, MMM D': 'dddd, D MMM',
    'MMM D, YYYY': 'D MMM, YYYY',
    'MMM D': 'D MMM',
    'MMMM D': 'D MMMM',
    'MMMM\xa0D': 'D\xa0MMMM',
    'ddd, MMM D': 'ddd, D MMM',
    'MMMM D, YYYY': 'D MMMM, YYYY',
    'MMMM\xa0D, YYYY': 'D\xa0MMMM, YYYY',
  },
}

const timeOffs = {
  holiday: {
    color: '#F6E4BB',
    icon: 'holiday_14px.svg',
    image: 'Holidays.svg',
  },
  'days-off': {
    color: '#EBD2AE',
    icon: 'smile_14px.svg',
    image: 'Day-Off.svg',
  },
  sick: {
    color: '#FAD3B2',
    icon: 'sick_14px.svg',
    image: 'Sickness.svg',
  },
}

const emojis = { EMOJI_CLAP_HANDS: '👋', EMOJI_CLOCK: '⏰', EMOJI_HOURGLASS: '⏳', EMOJI_SPIRAL_NOTEPAD: '🗒️', EMOJI_GLOBE_WITH_MERIDIANS: '🌐' }
const emojisOfEntryType = { work: '💼', remote: '🏠', sick: '🌡️', holiday: '⛱️', 'days-off': '😉' }

function systemFullName(system) {
  if (system === 'slack') {
    return 'Slack'
  } else if (system === 'teams') {
    return 'MS Teams'
  } else if (system === 'discord') {
    return 'Discord'
  } else {
    return ''
  }
}

module.exports = {
  localeFormats,
  timeOffs,
  emojis,
  emojisOfEntryType,
  systemFullName,
}
